import { Grid } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";

function PrivacyNotice(props: any) {
  const { open, setOpen } = props;

  return (
    <>
      <DialogFormation
        title="Notice Regarding the Collection of Personal Data"
        openDialog={open}
        handleClose={() => setOpen(false)}
        actionConfig={
          <div className="modal-config-wrapper">
            <Button onClick={() => setOpen(false)} label={"Close"}></Button>
          </div>
        }
      >
        <Grid
          component={"div"}
          gap="16px"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}
        >
          <Typography component={"div"} variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left">
            By using{" "}
            <Typography component={"span"} showBold>
              the BOOST application
            </Typography>
            , Hilton Worldwide Holdings Inc. and its direct and indirect subsidiaries (“Hilton”, “we”, “our” or “us”)
            may collect the following personal data about you:
            <ul>
              <li>Your name </li>
              <li>Your HLT IDM ID </li>
              <li>Your email address </li>
              <li>Your physical address </li>
              <li>Your work title </li>
              <li>Organization</li>
              <li>Department </li>
              <li>Management Type </li>
              <li>Brand </li>
              <li>InnCode </li>
              <li>Persona (combination of employee type and O365 User Indicator) </li>
              <li>Lobby User Type </li>
              <li>IP address </li>
              <li>Language </li>
              <li>Browser name </li>
              <li>Browser version </li>
              <li>Device type </li>
              <li>Operating system </li>
            </ul>
            By providing the personal data listed above, you are consenting to Hilton collecting and processing that
            data. Hilton (or “we”) will use your personal data solely for the purposes of engagement analytics. We will
            keep the personal information we obtained confidential to the extent possible and will only share it with
            Pendo, our third-party analytics vendor, or as required by law.
          </Typography>
          <Typography variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left">
            We retain your data for the period of time required by law or, if there is no law that governs, for as long
            as necessary for business purposes.
          </Typography>
          <Typography variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left" showBold>
            If you do not consent to providing your personal data, please contact us immediately at
            <a target={"_blank"} href="mailto: privacy@hilton.com" rel="noreferrer">
              {" "}
              privacy@hilton.com
            </a>
            .
          </Typography>
          <Typography variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left">
            If you would like further information about the personal information that is collected about you, or if you
            would like to correct your personal information, restrict the processing of your personal information, or
            make a request for us to delete your personal information, please visit our website at datarights.hilton.com
            or click the “Personal Data Requests” link at the bottom of any Hilton website to submit your request. You
            also may email the Data Protection Office at DataProtectionOffice@Hilton.com or send a letter to the Data
            Protection Office at 7930 Jones Branch Drive, McLean, Virginia, USA 22102.
          </Typography>
          <Typography variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left">
            Depending on the country in which you reside, you may have the right to file a complaint concerning our
            processing of your personal data with a regulator in that country. Please contact the Data Protection Office
            if you would like additional information about that potential right.
          </Typography>
        </Grid>
      </DialogFormation>
    </>
  );
}

export default PrivacyNotice;
